import React from "react";

export default () => (
  <div>
    <h1>Not allowed</h1>
    <p>Please login</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/NotAllowed/NotAllowed.js